import { ActivationExceptionType } from "../../../chats/~store/models/enums/ActivationExceptionType"

export const GetActivationExceptionString = (type: number): string => {
    switch(type){
        case ActivationExceptionType.LicenseAlreadyActivated: return 'license.licenseAlreadyActivatedMessage';
        case ActivationExceptionType.LicenseExpired: return 'license.licenseExpiredErrorMessage';
        case ActivationExceptionType.LoginFormatError: return 'license.loginFormatErrorMessage';
        case ActivationExceptionType.UserAlreadyExist: return 'license.userAlreadyExistMessage';
        case ActivationExceptionType.FailedLicenseValidation:
        default: return 'license.licenseErrorMessage';
    }
}